import { useAppSelector } from "hooks/store"
import { selectDataAuth } from "store/auth/auth.selectors"

export const useUserRole = () => {
  const authData = useAppSelector(selectDataAuth)

  return authData?.role
}
